import { Component, EventEmitter, Output } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { OrganizationPreferencesDataGridService } from '@piqet-angular/features';
import { GridCellInputComponent } from '../grid-cell-input/grid-cell-input.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { GridApi } from '@ag-grid-community/core';

@Component({
  selector: 'piqet-angular-edit-litter-impact',
  templateUrl: './edit-litter-impact.component.html',
  styleUrls: ['./edit-litter-impact.component.css'],
})
export class EditLitterImpactComponent {
  private gridApi!: GridApi;
  columnDefs: ColDef[];
  @Output() saveLitterImpactEvent = new EventEmitter<any>();
  frameworkComponents = {
    inputRenderer: GridCellInputComponent,
  };
  editLitterImpactList: any;
  eolListItems: any;
  updatedRecord: any;
  // editLitterImpactForm!: FormGroup;

  constructor(
    private organizationPreferencesDataGridService: OrganizationPreferencesDataGridService,
    private formBuilder: FormBuilder,
    private modal: CustomModalService
  ) {
    this.columnDefs = this.organizationPreferencesDataGridService.editLitterImpactDataColumn();
    this.editLitterImpactList =
      this.modal?.modalService?.config?.initialState?.['litterImpactFormData'];
    this.eolListItems = this.editLitterImpactList.eolListItem;
  }

  ngOnInit(): void {}

  onClose() {
    this.modal.close();
  }

  getUpdatedRecord(data: any) {
    this.updatedRecord = data;
  }

  onSave() {
    this.saveLitterImpactEvent.emit();
  }
}
